//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseDateYYYYMMDD, formatDateDDMMYYYY } from '../../../../../common/functions/date-utils';
import TooltipAjuda from '../../../../../shared-components/TooltipAjuda';

export default {
  name: 'TransferenciaPosseDefinitivaPasso4',
  components: {
    TooltipAjuda,
  },
  props: {
    transferencia: Object,
  },
  data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      fetchExtensaoFuncion: this.$api.extensao(this.$resource).listar,

      passo: 4,
      orcamentos: [],
      pagination: {},
      totalPage: 0,
      headers: [
        { text: this.$tc('label.orcamento', 1), value: 'orcamento', sortable: false },
        { text: this.$tc('label.marca', 1), value: 'marca', sortable: false },
        { text: this.$tc('label.linha_orcamento', 1), value: 'linha', sortable: false },
        { text: this.$tc('label.data_inicio', 1), value: 'dtaInicioOrcamento', sortable: false },
        { text: this.$tc('label.data_fim', 1), value: 'dtaFimOrcamento', sortable: false },
        { text: this.$tc('label.planejado', 1), value: 'vlrPlanejado', sortable: false },
        { text: this.$tc('label.reservado', 1), value: 'vlrReservado', sortable: false },
        { text: this.$tc('label.conf_negociacao', 1), value: 'vlrConfAcao', sortable: false },
        { text: this.$tc('label.conf_apuracao', 1), value: 'vlrConfApuracao', sortable: false },
        { text: this.$tc('label.consumido', 1), value: 'vlrConsumido', sortable: false },
        { text: this.$tc('label.acoes', 2), value: 'acoes', sortable: false },
        { text: `${this.$tc('label.transferir', 1)}?`, value: 'transferir', sortable: false },
      ],
      dataInicio: '',
      dataFim: '',
      menuDataInicio: false,
      menuDataFim: false,
      rules: {
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
        dataFimMaiorInicio: () => !this.isDataFimMaiorInicio() || this.$t('message.data_inicial_maior_final'),
      },
      filtroMarcas: [],
      marcas: [],
      searchMarca: null,
      selecionados: {},
    };
  },
  watch: {
    searchMarca(val) {
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(() => {
        if (val) this.buscarMarcas(val);
      }, 500);
    },
    pagination: {
      handler() {
        this.buscarOrcamentos(this.transferencia.funcionarioDe);
      },
      deep: true,
    },
  },
  computed: {
    dateInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataInicio);
      },
      set(newValue) {
        this.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
    dateFimFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataFim);
      },
      set(newValue) {
        this.dataFim = parseDateYYYYMMDD(newValue);
      },
    },
  },
  methods: {
    cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso() {
      const selecionados = Object.values(this.selecionados);
      if (selecionados.length === 0) {
        this.$toast.create(this.$t('message.nenhum_orcamento_selecionado_para_transferir'), 'snack', 3E3);
        return;
      }
      this.transferencia.orcamentos = [...selecionados];
      this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
    },
    voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    buscarOrcamentos(funcDe) {
      if (funcDe) {
        const params = {
          numeroPagina: this.pagination.page,
          tamanhoPagina: this.pagination.itemsPerPage,
          idUsuarioDe: funcDe.id,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
        };
        if (this.filtroMarcas.length) {
          params.marcas = this.filtroMarcas;
        }
        this.resources.orcamento(params).then((response) => {
          this.orcamentos = response.data.resposta;
          this.orcamentos.forEach((e) => {
            e.vlrPlanejado = e.vlrPlanejado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrReservado = e.vlrReservado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConfAcao = e.vlrConfAcao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConfApuracao = e.vlrConfApuracao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConsumido = e.vlrConsumido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          });
          this.totalPage = response.data.quantidadeRegistrosPagina;
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    limparFiltro() {
      this.lista = [];
      this.itensFiltro = [];
      this.selecionados = {};
    },
    aplicarFiltro() {
      this.selecionados = {};
      this.pagination.page = 1;
      this.buscarOrcamentos(this.transferencia.funcionarioDe);
    },
    isDataFimMaiorInicio() {
      const dtInicio = this.moment(this.dataInicio, 'YYYY-MM-DD');
      const dtFinal = this.moment(this.dataFim, 'YYYY-MM-DD');
      return dtFinal.isBefore(dtInicio);
    },
    buscarMarcas(busca = null) {
      if (typeof busca !== 'string') {
        busca = null;
      }
      const param = {
        idNivelExtensao: 2,
        nome: busca,
        indAtivo: true,
        size: 20,
        page: 1,
      };
      this.fetchExtensaoFuncion(param).then((response) => {
        this.marcas = response.data.resposta;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    selecionar(item) {
      const { orcamento, idLinha } = item;
      const chave = `${orcamento}-${idLinha}`;

      if (this.selecionados[chave] == null) {
        this.selecionados[chave] = item;
      } else {
        delete this.selecionados[chave];
      }
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso4.vue?vue&type=script&lang=js&